// document.addEventListener('DOMContentLoaded', () => {
//   const videos = document.querySelectorAll('.flickity-slider .is-selected .image_carousal_video');

//   function handleSlideChange() {
//     videos.forEach(video => {
//       // Check if video is in the active slide container
//       const slide = video.closest('video');
//       let videoParent = video.parentElement;
//       if (this.slide && this.videoParent.classList.contains('is-selected')) {
//         video.play().catch(() => {});  // Play video if visible, avoid errors
//       } else {
//         video.pause(); // Pause if not visible
//       }
//     });
//   }

//   // Listen for Shopify's slide change event or use MutationObserver if needed
//   document.querySelectorAll('.flickity-slider > div').forEach(slide => {
//     slide.addEventListener('transitionend', handleSlideChange);
//   });

//   // Initial check
//   handleSlideChange();
// });


// document.addEventListener('DOMContentLoaded', () => {
//   const mediaItems = document.querySelectorAll('.flickity-slider > div'); // Adjust selector to your theme

//   function updateVideoPlayback() {
//     mediaItems.forEach(item => {
//       const video = item.querySelector('video');
//       if (item.classList.contains('is-selected')) {
//         if (video) {
//           this.video.play();
//         }
//         else {

//         }
//       }
//     });
//   }

//   // Listen for slide change events; replace with actual event your theme fires, or watch for class changes
// //   mediaItems.forEach(item => {
// //     item.addEventListener('transitionend', updateVideoPlayback);
// //   });

//   updateVideoPlayback(); // Initial check on page load
// });

document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.flickity-slider > div video'); // Adjust selector as needed

  if ('IntersectionObserver' in window) {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.75 // Play when 75% of video is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(() => {}); // Play video when in viewport
        } else {
          video.pause(); // Pause video when out of viewport
          video.currentTime = 0; // Reset to start
        }
      });
    }, observerOptions);

    videos.forEach(video => {
      observer.observe(video);
    });
  } else {
    // Fallback for browsers not supporting IntersectionObserver
    videos.forEach(video => {
      video.pause();
    });
  }
});

// Hide Track Order in contact page
// function adjustGorgiasIframe() {
//   const iframe = document.querySelector("#gorgias-contact-form-wrapper iframe");
//   if (!iframe) return;

//   let wrapper = iframe.parentElement;

//   if (!wrapper.classList.contains("gorgias-iframe-wrapper")) {
//     wrapper = document.createElement("div");
//     wrapper.className = "gorgias-iframe-wrapper";
//     wrapper.style.overflow = "hidden";
   
//     iframe.parentNode.insertBefore(wrapper, iframe);
//     wrapper.appendChild(iframe);
//   }

//   iframe.style.marginTop = window.innerWidth <= 768 ? "-100px" : "-180px";
// }

// window.addEventListener("load", adjustGorgiasIframe);
// window.addEventListener("resize", adjustGorgiasIframe);